import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/apple': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M318.7 268.7c0 1.9-3.5 61.2 61.7 91.9-12.2 36.8-54 118.6-102.6 119.3-28.1 0-44.6-17.9-76.4-17.9-32.8 0-50.6 17.3-75.8 17.9-48.2 1.5-94.4-88.5-107.2-125.2-9.6-27.9-14.4-55-14.4-81.2 0-88.7 59.3-132.3 115.1-133.2 27 0 61.4 19.7 76.4 19.7 14.2 0 53-23.5 88.5-20.7 37.5 2.9 65.9 17.7 84.7 44.6-33.6 20.4-50.2 48.1-50 84.8zM262.1 104.5c-19.6 22.9-43.4 36.3-69.5 34.3-2.2-27.6 8.1-52.1 25.6-71.9 15.9-18.5 43.8-33.5 67.9-34.9 0.8 10.6 3.3 40.1-24 72.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/apple.js
// module id = 714
// module chunks = 0